import React, { useEffect, useRef  } from 'react';
import { Link } from "react-router-dom";
import { Tab, Nav, Badge } from "react-bootstrap";
import { Carousel } from 'react-bootstrap'
import $ from 'jquery';     
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';


const ManageMenu = () =>{
    const tableRef = useRef(null);

    const tabData = [
        {
          name: "Break Box",
        },
        {
          name: "Meals Box",
        },
        {
          name: "Anjaraipetti",
        },
    
        {
          name: "Dinner Box",
        },
      ];


    const currentDate = new Date();
  
    // Format the date to 'd-M-Y' (e.g., '12-Dec-2024')
    const formattedDate = currentDate.toLocaleDateString('en-GB', {
      month: 'long',
      year: 'numeric',
    });

    useEffect(() => {
        if (tableRef.current) {
          if (!$.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable({
              "responsive": true,
              "ordering": false,
              "language": {
                "lengthMenu": "Show _MENU_",
              },
              "dom":
                "<'row'" +
                "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                ">" +
                "<'table-responsive'tr>" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                ">",
            });
      
            // Set the table width to 80% inline
            $(tableRef.current).css({
              width: '80%',
              margin: '0 auto',  // Optional, for centering
            });
          }
        }
      }, []);


    return(
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Manage Mega Menu</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Menus</li>
                    </ol>
                </div>
                <Link to={'/add-menumaker'} className="btn btn-primary float-end btn-sm">
                    <span className='me-2'><i class="fa-solid fa-plus fs-8"></i></span>
                    <span className=''>Add Menu</span>
                </Link>
            </div>
            <div className="default-tab">
                <Tab.Container defaultActiveKey={tabData[0].name.toLowerCase()}>
                  <Nav as="ul" className="nav-tabs">
                    {tabData.map((data, i) => (
                      <Nav.Item as="li" key={i}>
                        <Nav.Link eventKey={data.name.toLowerCase()}>
                          {data.name}
                        </Nav.Link>
                      </Nav.Item>
                    ))}
                  </Nav>
                  <Tab.Content className="pt-4">
                    {tabData.map((data, i) => (
                      <Tab.Pane eventKey={data.name.toLowerCase()} key={i}>
                        <div className='d-flex align-items-center justify-content-between mb-4'>
                            <h4>{formattedDate}</h4>
                            <Link to={"#"} className="btn btn-primary float-end btn-sm">
                                <i class="fa-solid fa-print fs-5"></i>
                            </Link>
                        </div>
                       <Carousel>
                            <div className="table-container">
                                <table ref={tableRef} id="kt_ datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                    <thead>
                                        <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head" style={{backgroundColor:'#ea1d25', color:'#000000'}}>
                                            <th className='min-w-100px'></th>
                                            <th className='min-w-100px'></th>
                                            <th className='min-w-100px'>Week 1</th>
                                            <th className='min-w-100px'></th>
                                            <th className='min-w-100px'></th>
                                        </tr>
                                        <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                            <th className='min-w-100px text-center'>Date/Day</th>
                                            <th className='min-w-100px'>Main Dish 1</th>
                                            <th className='min-w-100px'>Main Dish 2</th>
                                            <th className='min-w-100px'>Side Dish 1</th>
                                            <th className='min-w-100px'>Side Dish 2</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-gray-600 fw-semibold fs-7">
                                        <tr>
                                            <td className='text-center'>
                                                <label className='text-black font-w400 fs-7'>01-Dec-2024</label>
                                                <div className="d-block">
                                                    <Badge bg="secondary" className='text-black font-w700 fs-8 py-0 px-1'>Sunday</Badge>
                                                </div>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Idly (03)</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Uthappam (03)</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Sambar</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Mint Chutney</label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='text-center'>
                                                <label className='text-black font-w400 fs-7'>02-Dec-2024</label>
                                                <div className="d-block">
                                                    <Badge bg="secondary" className='text-black font-w700 fs-8 py-0 px-1'>Monday</Badge>
                                                </div>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Multigrain Adai (03)</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Idly (03)</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Sambar</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Coriander Chutney</label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='text-center'>
                                                <label className='text-black font-w400 fs-7'>03-Dec-2024</label>
                                                <div className="d-block">
                                                    <Badge bg="secondary" className='text-black font-w700 fs-8 py-0 px-1'>Tuesday</Badge>
                                                </div>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Masala Dosai (03)</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Aval Pongal</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Sambar</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Coconut Chutney</label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='text-center'>
                                                <label className='text-black font-w400 fs-7'>04-Dec-2024</label>
                                                <div className="d-block">
                                                    <Badge bg="secondary" className='text-black font-w700 fs-8 py-0 px-1'>Wednesday</Badge>
                                                </div>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Carrot Uthappam (03)</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Ragi Puttu</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Spicy Chutney</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Kadalai Curry</label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='text-center'>
                                                <label className='text-black font-w400 fs-7'>05-Dec-2024</label>
                                                <div className="d-block">
                                                    <Badge bg="secondary" className='text-black font-w700 fs-8 py-0 px-1'>Thursday</Badge>
                                                </div>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Veg Kitchadi</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Kanchipuram Idly (03)</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Sambar</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Tomato Chutney</label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='text-center'>
                                                <label className='text-black font-w400 fs-7'>06-Dec-2024</label>
                                                <div className="d-block">
                                                    <Badge bg="secondary" className='text-black font-w700 fs-8 py-0 px-1'>Friday</Badge>
                                                </div>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Idly (03)</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Coconut Sevai</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Sambar</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Corainder Chutney</label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='text-center'>
                                                <label className='text-black font-w400 fs-7'>07-Dec-2024</label>
                                                <div className="d-block">
                                                    <Badge bg="secondary" className='text-black font-w700 fs-8 py-0 px-1'>Saturday</Badge>
                                                </div>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Idly (03)</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Set Dosai (03)</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Vada Curry</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>Sambar</label>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Carousel>
                      </Tab.Pane>
                    ))}
                  </Tab.Content>
                </Tab.Container>
              </div>
        </>
    )

    
}
export default ManageMenu;